import React from "react";
import { EcomotoLogo } from "../../assets/images";

type DefaultSplashScreenProps = {
  handleNext: () => void;
};
const DefaultSplashScreen: React.FC<DefaultSplashScreenProps> = ({
  handleNext,
}) => {
  return (
    <div className="font-BRFirma lg:hidden h-full flex flex-col justify-between">
      <div className="flex h-[45%] bg-midGreen w-full justify-center items-center flex-wrap">
        <div className="flex h-[400px] w-[600px] justify-center items-center pt-[132px] bg-midGreen rounded-b-full">
          <img src={EcomotoLogo} alt="" className="w-[155px] h-[162.5px]" />
        </div>
      </div>
      <div className="flex flex-col h-[50%] w-full items-center justify-center px-[100px] pt-8">
        <div className="font-bold text-midGreen text-center text-[30px] leading-none">
          Welcome <br /> to Ecobook.
        </div>
        <p className="text-[15px] font-medium text-[#8A97A0] break-words whitespace-pre-line text-pretty px-4 mt-2">
          The town square for the Ecomoto community-lessors and lessees.
        </p>
        <p className="text-[15px] font-medium text-[#8A97A0] break-words whitespace-pre-line px-4 text-pretty my-2">
          Here, you can socialize, network, and share content (video, pictures,
          infographics, etc.)
        </p>
        <div
          className="items-center cursor-pointer bg-midGreen flex justify-center text-center font-Poppins font-medium text-lg w-[370px] h-[50px] text-white rounded-2xl"
          onClick={handleNext}
        >
          Next
        </div>
      </div>
    </div>
  );
};

export default DefaultSplashScreen;
